import { successState } from 'src/actions/global.actions'
import { actions } from 'src/actions/clientOpt.actions'

const initialState: ClientDetailState = {
  detail: {
    name: '',
    code: '',
    identifications: [],
    categories: [],
  },
}

const ClientOptReducer = (state = initialState, { type, payload }): ClientDetailState => {
  switch (type) {
    case successState(actions.detail):
      return { ...state, detail: payload }
    default:
      return state
  }
}
export default ClientOptReducer
